export const SCREEN = {
  CloneMe: 'CloneMe',
  Home: 'Home',
  Statements: 'Statements',
  Learnings: 'Learnings',
};
